module.exports = __webpack_public_path__ + "img/mb-streets.06787fc3.png";